export const defaultI18nMessage = (pack, name, message) => {
    return {
        id: `${pack}_${name}`,
        defaultMessage: message,
    }
}